import { type FC, useCallback } from 'react';

import {
	type AccommodationSectionType,
	MENU_SCROLL_DURATION,
	MENU_OFFSET,
} from '@vakantiesnl/components/src/utils/accoSections';
import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';
import { useApplicationStore } from '@vakantiesnl/services/src/stores/applicationStore';
import { scroller } from 'react-scroll';

import { PaginationComponent } from './Pagination';

type Props = {
	total: number;
	page: number;
	pageSize: number;
	setPageFn: (value: number) => void;
	scrollToElement?: AccommodationSectionType;
};

export const Pagination: FC<Props> = ({ total, pageSize, page, setPageFn, scrollToElement }) => {
	const microCopies = useMicroCopyContext();
	const isBot = useApplicationStore((s) => s.isBot);

	const updatePage = useCallback(
		(newPage: number) => {
			setPageFn(newPage);

			if (scrollToElement) {
				scroller.scrollTo(scrollToElement, {
					duration: MENU_SCROLL_DURATION,
					smooth: true,
					offset: MENU_OFFSET,
				});
			}
		},
		[setPageFn, scrollToElement],
	);

	const pageCount = Math.ceil(total / pageSize);

	if (pageCount === 1) return null;

	return (
		<PaginationComponent
			pageCount={pageCount}
			currentPage={page}
			microCopies={microCopies}
			setValue={updatePage}
			isBot={isBot}
		/>
	);
};
